import { useState, useEffect } from 'react';

// Variables to manage the timer centrally
let intervalId = null;
let intervalRefCounter = 0;

const circulatingSupply = 6426120416.616;
const totalSupply = 94938206930.825;

const usePriceVolumeData = () => {
  const [priceVolumeData, setPriceVolumeData] = useState({
    priceVolumeData: null,
    stats: null
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const priceVolumeDataResponse = await fetch('https://api.0lswap.com/orders/getChartData?interval=1h&market=OLUSDT');
        const priceVolumeData = await priceVolumeDataResponse.json();

        const lastTransactionPrice = parseFloat(priceVolumeData[priceVolumeData.length - 1].close);
        const yesterday = new Date(Date.now() - 24 * 60 * 60 * 1000);
        const volume24Hr = priceVolumeData
          .filter(order => new Date(order.time) > yesterday)
          .reduce((acc, order) => acc + (order.price * order.amount), 0);

        const marketCap = circulatingSupply * lastTransactionPrice;
        const fullyDilutedMarket = totalSupply * lastTransactionPrice;

        setPriceVolumeData({
          priceVolumeData: priceVolumeData,
          stats: {
            lastTransactionPrice: lastTransactionPrice,
            volume24Hr: volume24Hr,
            marketCap: marketCap,
            fullyDilutedMarket: fullyDilutedMarket,
            circulatingSupply: circulatingSupply,
            totalSupply: totalSupply,
          }
        });
      } catch (error) {
        console.error('Failed to fetch market data:', error);
      }
    };

    // Increment the reference counter and create the interval if necessary
    if (intervalRefCounter === 0) {
      intervalId = setInterval(fetchData, 30000);
    }
    intervalRefCounter += 1;

    // Initial immediate call
    fetchData();

    // Cleanup function
    return () => {
      intervalRefCounter -= 1;
      if (intervalRefCounter === 0) {
        clearInterval(intervalId);
        intervalId = null;
      }
    };
  }, []);

  return priceVolumeData;
}

export default usePriceVolumeData;
